import type { AzureBlobRuntimeOptions, RuntimeStorageBackend } from "./storage-types.js";

export function normalizeRuntimeStorageBackend(value: string | undefined): RuntimeStorageBackend {
  const normalized = value?.trim();
  if (!normalized || normalized === "local-filesystem") return "local-filesystem";
  if (normalized === "azure_blob") return "azure_blob";
  throw new Error(`Unsupported GENCOW_STORAGE_BACKEND: ${normalized}`);
}

export function isLegacyLocalFallbackEnabled(value: string | undefined): boolean {
  return value === "1" || value?.toLowerCase() === "true";
}

function readRequiredEnv(env: NodeJS.ProcessEnv, key: string): string {
  const value = env[key]?.trim();
  if (value) return value;
  throw new Error(`${key} is required when GENCOW_STORAGE_BACKEND=azure_blob`);
}

export function readAzureBlobRuntimeOptionsFromEnv(env: NodeJS.ProcessEnv): AzureBlobRuntimeOptions {
  const auth = env.GENCOW_PLATFORM_STORAGE_AZURE_AUTH?.trim() || "managed_identity";
  if (auth !== "managed_identity" && auth !== "client_secret") {
    throw new Error(`Unsupported GENCOW_PLATFORM_STORAGE_AZURE_AUTH: ${auth}`);
  }
  const directUploadMode = env.GENCOW_PLATFORM_STORAGE_AZURE_DIRECT_UPLOAD?.trim() || "api_route";
  if (directUploadMode !== "api_route" && directUploadMode !== "azure_sas") {
    throw new Error(`Unsupported GENCOW_PLATFORM_STORAGE_AZURE_DIRECT_UPLOAD: ${directUploadMode}`);
  }
  return {
    accountName: readRequiredEnv(env, "GENCOW_PLATFORM_STORAGE_AZURE_ACCOUNT_NAME"),
    containerName: readRequiredEnv(env, "GENCOW_PLATFORM_STORAGE_AZURE_CONTAINER"),
    endpoint: readRequiredEnv(env, "GENCOW_PLATFORM_STORAGE_AZURE_ENDPOINT").replace(/\/+$/, ""),
    prefix: env.GENCOW_PLATFORM_STORAGE_AZURE_PREFIX?.trim() || "prod",
    auth,
    directUploadMode,
    clientId: env.GENCOW_PLATFORM_STORAGE_AZURE_CLIENT_ID?.trim(),
    tenantId: env.GENCOW_PLATFORM_STORAGE_AZURE_TENANT_ID?.trim(),
    clientSecret: env.GENCOW_PLATFORM_STORAGE_AZURE_CLIENT_SECRET,
  };
}
